<mat-card class="m-auto padding12 home-card boxshadowgrey">
    <div>
        <button mat-icon-button color="primary" class="back-button" routerLink="/menu">
            <mat-icon>arrow_back</mat-icon>
        </button>
    </div>

    <div class="content">
    <mat-card-title-group class="home-card" id="title">
        <mat-card-title>{{"MASCHINESTATE.HEADER" | translate}}</mat-card-title>
        <mat-card-subtitle>{{"MASCHINESTATE.SUBTITLE" | translate}}</mat-card-subtitle>
        
    </mat-card-title-group>

    <mat-card-content>
        <div class="home-card" id="content">
            <div class="home-nav">
                <div class="home-nav-menu" cdkMenu>
                    <button mat-stroked-button class="mat-item-button" cdkMenuItem routerLink="joystick" color="primary">
                        <div class="button-label">
                            <mat-icon svgIcon="joystick"></mat-icon>
                            <span class="menu-item-label">{{"MASCHINESTATE.JOYSTICK.HEADER" | translate}}</span>
                        </div>
                    </button>

                    <button mat-stroked-button class="mat-item-button" cdkMenuItem routerLink="currents-equipment" color="primary">
                        <div class="button-label">
                            <mat-icon>bolt</mat-icon>
                            <span class="menu-item-label">{{"MASCHINESTATE.CURRENTS.MENUHEADER" | translate}}</span>
                        </div>
                    </button>

                    <button mat-stroked-button class="mat-item-button" cdkMenuItem routerLink="pressure-equipment" color="primary">
                        <div class="button-label">
                            <mat-icon svgIcon="pressure"></mat-icon>
                            <span class="menu-item-label">{{"MASCHINESTATE.PRESSURE.MENUHEADER" | translate}}</span>
                        </div>
                    </button>

                    <button mat-stroked-button class="mat-item-button" cdkMenuItem routerLink="position" color="primary">
                        <div class="button-label">
                            <mat-icon svgIcon="boomAngleIcon"></mat-icon>
                            <span class="menu-item-label">{{"MASCHINESTATE.POSITION.MENUHEADER" | translate}}</span>
                        </div>
                    </button>

                    <button mat-stroked-button class="mat-item-button" cdkMenuItem routerLink="graph-equipment" color="primary">
                        <div class="button-label">
                            <mat-icon>legend_toggle</mat-icon>
                            <span class="menu-item-label">{{"MASCHINESTATE.GRAPH.MENUHEADER" | translate}}</span>
                        </div>
                    </button>

                    <button mat-stroked-button class="mat-item-button" cdkMenuItem routerLink="operation-times" color="primary">
                        <div class="button-label">
                            <mat-icon svgIcon="MachineHours"></mat-icon>
                            <span class="menu-item-label">{{"MASCHINESTATE.TIMES.HEADER" | translate}}</span>
                        </div>
                    </button>

                </div>
            </div>
            <div class="home-image" id="container">
                <ng-container *ngIf="imgExist">
                    <img class="home-image" src="../../assets/images/machine/renderings/{{this.machinenumber.split('.')[0]}}.png" height="1350" width="1080" alt="Sennebogen Machine" (error)="updateImg()"/>
                </ng-container>
            </div>
        </div>
    </mat-card-content>
</div>
</mat-card>
